'use client';

import { InstructionReadSection } from './property-instruction/instruction-read-section';
import { InstructionEditSection } from './property-instruction/instruction-edit-section';
import type { PropertyInstructionSectionProps } from './property-instruction/constants';

export type { PropertyInstructionSectionProps };

export function PropertyInstructionSection(
  props: PropertyInstructionSectionProps
) {
  if (props.mode === 'read') {
    return <InstructionReadSection {...props} />;
  }

  return <InstructionEditSection {...props} />;
}
